import { component$, Slot } from "@builder.io/qwik";

export const ImageWithCaption = component$<{ caption: string }>(
  ({ caption }) => (
    <figure class="flex w-full flex-col items-center gap-2 rounded border border-gray-200 bg-gray-50 p-4">
      <div class="w-full overflow-hidden rounded">
        <Slot />
      </div>
      <figcaption class="text-tertiary w-full text-left text-sm">
        {caption}
      </figcaption>
    </figure>
  ),
);
